import React, { useState, useRef, useEffect } from "react";
import { Globe, Check, ChevronDown } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const LanguageSwitcher = () => {
  const { lang, changeLang, languages } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const current = languages.find((l) => l.code === lang);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        className="glass-btn px-3.5 py-2 text-sm font-medium"
        aria-label="Change language"
      >
        <Globe className="h-4 w-4" />
        <span>{current?.label}</span>
        <ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="glass-card absolute right-0 mt-2 w-44 rounded-xl p-1.5 z-50 animate-fade-up">
          {languages.map((l) => (
            <button
              key={l.code}
              onClick={() => {
                changeLang(l.code);
                setOpen(false);
              }}
              className="flex w-full items-center justify-between rounded-lg px-3 py-2 text-sm text-white/85 hover:bg-white/10 transition-colors"
            >
              <span>
                <span className="font-semibold mr-2">{l.label}</span>
                <span className="text-white/50">{l.name}</span>
              </span>
              {lang === l.code && <Check className="h-4 w-4" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
